import React from 'react';
import styled, { css } from 'styled-components';
import colors from '../../../vars/colors';
import { Column } from '../../global/grid/grid';
import breakpoints from '../../../vars/breakpoints';

export const QuoteModule = styled.div`
    @media (max-width: ${breakpoints['bp-mobile']}) {
        .imageColumn {
            order: 2;
        }
    }
`;

export const QuoteWrapper = styled(Column)`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: relative;    
    @media (max-width: ${breakpoints['bp-mobile']}) {
        margin-bottom: 30px;
        .imageColumn {            
            order: 1;
        }
    }
`;

export const Statement = styled.div`
    font-family: 'OneDotCd', sans-serif;
    font-size: 50px;
    font-weight: bold;
    color: ${ props => props.color === 'red' ? colors['lipstick'] : colors['peacock-blue']};
    text-transform: uppercase;
    font-style: italic;
    font-weight: bold;
    width: 100%;
    @media (max-width: ${breakpoints['bp-mobile']}) {
        font-size: 28px;
    }
    &::before {
        font-family: 'OneDotCd', sans-serif;
        content: "\\201C";
        font-weight: bold;
        color: ${ props => props.color === 'red' ? colors['lipstick'] : colors['peacock-blue']};
        text-transform: uppercase;
        font-style: italic;
        font-weight: bold;
        position: relative;
        display: inline-block;
    }
    &::after {
        content: "\\201D";
    }
`;

export const Attribution = styled.div`
    font-family: 'OneDotExt', sans-serif;
    font-size: 15px;
    font-weight: bold;
    font-style: italic;
    color: ${colors['black']};
    text-transform: uppercase;
    margin-top: 10px;
    &::before {
        content: '— ';
    }
`;



// WEBPACK FOOTER //
// ./src/components/modules/Quote/styled-components.js